import React from 'react';
import { SupportIcon } from '../../icons/SupportIcon';
import { ExternalLinkIcon } from '../../icons/ExternalLinkIcon';
import { ActionText } from '../../components/Flex';
import { DropdownButton } from '../../components/Button';

const SupportButton = ({ handleMenuClick }) => {
    return(
        <DropdownButton
            placement="bottomLeft"
            margin={12}
            items={[
                { key: 0, title: <a target="_blank" href="https://forum.vmssoftware.com/">
                    <ActionText gap={{right: 8}}>
                        <span>Official Forum</span>
                        <ExternalLinkIcon size={16} />
                    </ActionText>
                </a>},
                { key: 2, title: <a target="_blank" href="https://di37l.share.hsforms.com/2GJWun9ZJQye0Vfjti8ffvQ">
                    <ActionText gap={{right: 8}}>
                        <span>Share your feedback</span>
                        <ExternalLinkIcon size={16} />
                    </ActionText>
                </a>},
                { key: 1, title: "Contact Support"}
            ]}
            onMenuClick={({ key }) => handleMenuClick(key)}
        >
            <SupportIcon />
        </DropdownButton>
    );
};


export { SupportButton };
